import { NAME } from './constants';

export const SET_SPORT = `${NAME}/SET_SPORT`;

export const FETCH_SITE_LIST = `${NAME}/FETCH_SITE_LIST`;
export const SET_SITE_LIST = `${NAME}/SET_SITE_LIST`;

export const FETCH_LEAGUE_DATA = `${NAME}/FETCH_LEAGUE_DATA`;
export const SET_LEAGUE_DATA = `${NAME}/SET_LEAGUE_DATA`;

export const FETCH_SITE_DETAILS = `${NAME}/FETCH_SITE_DETAILS`;
export const VALIDATE_PARTIAL_SITE_DETAILS = `${NAME}/VALIDATE_PARTIAL_SITE_DETAILS`;
export const UPDATE_SITE_DNS = `${NAME}/UPDATE_SITE_DNS`;

export const ADD_SITE_DETAILS = `${NAME}/ADD_SITE_DETAILS`;
export const EDIT_SITE_DETAILS = `${NAME}/EDIT_SITE_DETAILS`;
export const UPDATE_SITE_DETAILS = `${NAME}/UPDATE_SITE_DETAILS`;

export const SET_VALIDATION_ERRORS = `${NAME}/SET_VALIDATION_ERRORS`;
export const CLEAR_VALIDATION_ERRORS = `${NAME}/CLEAR_VALIDATION_ERRORS`;
export const SET_VALIDATED_PATHS = `${NAME}/SET_VALIDATED_PATHS`;

export const SET_STAGED_EDITS = `${NAME}/SET_STAGED_EDITS`;
export const CLEAR_STAGED_EDITS = `${NAME}/CLEAR_STAGED_EDITS`;

export const SET_DETAIL_MODE = `${NAME}/SET_DETAIL_MODE`;
export const RESET_SITE_DATA = `${NAME}/RESET_SITE_DATA`;

export const FETCH_SITE_CONFIG_TEMPLATES = `${NAME}/FETCH_SITE_CONFIG_TEMPLATES`;
export const SET_TEMPLATE_LIST_IS_LOADING = `${NAME}/SET_TEMPLATE_LIST_IS_LOADING`;
export const SET_SITE_CONFIG_TEMPLATES = `${NAME}/SET_SITE_CONFIG_TEMPLATES`;

export const SET_IS_LOADING = `${NAME}/SET_IS_LOADING`;
export const SET_IS_SAVING = `${NAME}/SET_IS_SAVING`;

export const ACTIVATE_SITE = `${NAME}/ACTIVATE_SITE`;
export const DEACTIVATE_SITE = `${NAME}/DEACTIVATE_SITE`;
export const SOFT_ACTIVATE_SITE = `${NAME}/SOFT_ACTIVATE_SITE`;
export const SOFT_DEACTIVATE_SITE = `${NAME}/SOFT_DEACTIVATE_SITE`;

export const SELECT_SITE = `${NAME}/SELECT_SITE`;
export const UNSELECT_SITE = `${NAME}/UNSELECT_SITE`;

export const SELECT_ALL_SITES = `${NAME}/SELECT_ALL_SITES`;
export const UNSELECT_ALL_SITES = `${NAME}/UNSELECT_ALL_SITES`;

export const SET_FILTER_DEFS_VALUE = `${NAME}/SET_FILTER_DEFS_VALUE`;

export const SET_PARENT_SITE = `${NAME}/SET_PARENT_SITE`;
export const UNSET_PARENT_SITE = `${NAME}/UNSET_PARENT_SITE`;

export const SET_SITE_TOKENS = `${NAME}/SET_SITE_TOKENS`;
export const CLEAR_SITE_TOKENS = `${NAME}/CLEAR_SITE_TOKENS`;

export const FETCH_SITE_TOKENS = `${NAME}/FETCH_SITE_TOKENS`;
export const EDIT_SITE_TOKEN = `${NAME}/EDIT_SITE_TOKEN`;
export const GENERATE_SITE_TOKEN = `${NAME}/GENERATE_SITE_TOKEN`;

export const FETCH_SITE_HISTORY = `${NAME}/FETCH_SITE_HISTORY`;
export const SET_SITE_HISTORY = `${NAME}/SET_SITE_HISTORY`;
export const CLEAR_SITE_HISTORY = `${NAME}/CLEAR_SITE_HISTORY`;
export const SET_SITE_HISTORY_IS_LOADING = `${NAME}/SET_SITE_HISTORY_IS_LOADING`;

export const FETCH_SITE = `${NAME}/FETCH_SITE`;
